module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_09B.42c7abfe.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_09B.mp3
// module id = 111
// module chunks = 0